import React, {Component} from 'react';
import './Search.css';
import SearchIcon from './SearchIcon';
import Toggle from './Toggle'
//============================================================================
// expected props: onSearch func param query

export default class Search extends Component {
    constructor(props) {
	    super(props);
	    this.state = {
            query: "",
            showForm: false,
	    };
	}
    updateMobileQuery(e){
        this.setState({query:this.refs.querymobile.value})
    }
    updateDesktopQuery(e){
        this.setState({query:this.refs.querydesktop.value})
    }
    submitQuery(){
        this.props.onSearch(this.state.query);
    }
    openMobileSearchForm(e){
        this.setState(Object.assign(this.state, {showForm: !this.state.showForm}));
    }
    updateToggle(bool){
        this.setState(Object.assign(this.state, {showForm: !this.state.showForm}));
    }

    render(){

        let  showForm = (bool) => {
            let _return =  (this.state.showForm === bool) ? 'flex' : 'none';
            return _return;
        };
        let updateWidth = (bool) => {
            return (bool)? '100%': '0%';
        }

        return (
            <form onSubmit={(e) => {this.submitQuery(e); e.preventDefault();}} 
                style={{"textAlign":"left", "marginBottom":"-25px"}}
                ref={el => this.form = el}
                >
                <div>
                    <h4 style={{
							"textAlign":"left", 
							"marginBottom":"-20px"}}>
                        Select Your Movies
                        <small className="search-mobile">
                            <Toggle 
                                label="Show search" 
                                updateState={(isChecked)=>{this.updateToggle(isChecked)}} 
                                checked={this.state.showForm}/>
                        </small>
                    </h4>
                    <div className="search">
                        <div className="search-desktop">
                            <div className="search-form-group input-group">
                                <input ref="querydesktop" onChange={this.updateDesktopQuery.bind(this)} type="text" value={this.state.query} className="search-input" />
                                <button className="search-btn" onClick={() => this.submitQuery()}><SearchIcon/></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="search-mobile__form" style={{width: updateWidth(this.state.showForm), clear: 'both'}}>
                    <div className="search-mobile__fieldset" style={{display:showForm(true), margin:'25px 0px 10px 0px'}}>
                        <div className="search-form-group input-group" >
                            <input ref="querymobile"
                                onChange={this.updateMobileQuery.bind(this)}
                                type="text"
                                value={this.state.query}
                                className="search-input"
                                style={{borderLeftWidth: '0px'}} />
                            <button className="search-btn" onClick={() => this.submitQuery()}><SearchIcon/></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}